import React, { useEffect, useState } from "react";
import { Card, Table, Badge, Spinner } from "react-bootstrap";
import { supabase } from "../../config/Supabase";

const STATUS_VARIANTS = {
  scheduled: "secondary",
  sent: "success",
  failed: "danger",
};

const formatMoney = (cents, currency = "USD") => {
  const amount = (cents || 0) / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);
};

const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-US", { dateStyle: "medium" }) : "—";

const PayoutHistory = ({ affiliateId }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!affiliateId) return;
    let cancelled = false;
    const fetchRows = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("affiliate_payouts")
        .select("*")
        .eq("affiliate_id", affiliateId)
        .order("created_at", { ascending: false });

      if (cancelled) return;
      if (error) {
        console.error("Failed to load payouts:", error);
        setRows([]);
      } else {
        setRows(data || []);
      }
      setLoading(false);
    };
    fetchRows();
    return () => {
      cancelled = true;
    };
  }, [affiliateId]);

  return (
    <Card className="shadow-sm" style={{ border: "none" }}>
      <Card.Body>
        <h5 className="mb-3">Payout History</h5>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" />
          </div>
        ) : rows.length === 0 ? (
          <p style={{ color: "#888", textAlign: "center", margin: "24px 0" }}>
            No payouts yet. Once your pending balance is processed it'll show
            up here.
          </p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Paid At</th>
                  <th>Reference</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>
                      {formatDate(row.period_start)} –{" "}
                      {formatDate(row.period_end)}
                    </td>
                    <td>{formatMoney(row.amount_cents, row.currency)}</td>
                    <td>
                      <Badge bg={STATUS_VARIANTS[row.status] || "secondary"}>
                        {row.status}
                      </Badge>
                    </td>
                    <td>{formatDate(row.paid_at)}</td>
                    <td>{row.external_ref || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default PayoutHistory;
